import { useContext } from 'react';
import { OnSpotContext } from '../../index';
import { OnSpotContextProps } from '@/model/onSpot/OnSpot';
import Icon from '@/comp/icon/icon';

export const ReviewContact = () => {
    const { contactData } = useContext(OnSpotContext) as OnSpotContextProps;

    return (
        <article>
            <div className="container">
                <h2 className="color-primary">
                    <Icon name="accountCircle" size={28} ariaHidden /> Ihre Kontaktdaten
                </h2>
                <div className="question-container">
                    <h4>Ihre E-Mail-Adresse</h4>
                    <div className="answer">{contactData.mail}</div>
                    <h4>Ihre Mobilfunknummer</h4>
                    <div className="answer">{`${contactData.mobile.phoneCountryPrefix} ${contactData.mobile.phoneAreaCode} ${contactData.mobile.phoneNumber}`}</div>
                </div>
            </div>
        </article>
    );
};
export default ReviewContact;
